export default {
  home: 'Home',

  // Smart search
  'smart-search.suggestions': 'Suggestions',
  'smart-search.facilities': 'Search facilities',
  'smart-search.prev-facilities': 'Facilities you visited',
  'smart-search.suggestion.my-appointments': 'My appointments',
  'smart-search.suggestion.my-documents': 'My documents',
  'smart-search.suggestion.new-appointment': 'Book appointment',

  // Partners
  'our-partners': 'Customers and partners',
  'our-partners.description': 'We cooperate closely with our customers & partners.',

  'home.info.1': 'Medical appointments revolutionized',
  'home.info.1.tag': 'Procedure',
  'home.info.1.subtitle': 'Simple. Safe. Fast.',
  'home.info.1.text':
    'With the {tenant} patient portal, you are accompanied throughout the entire journey of a treatment. We offer services for before, during and after your visit. You can book and manage your appointments conveniently from home. To do so, select the desired consultation hour and make your desired appointment.',

  'home.info.2': 'Appointment booking',
  'home.info.2.subtitle': 'Book appointments online now',
  'home.info.2.text': 'Appointment booking',
  'home.info.2.option-1.title': 'Select facility',
  'home.info.2.option-1.sub-title': 'Choose a facility from our partner clinics',

  'home.info.2.option-2.title': 'Select date and time',
  'home.info.2.option-2.sub-title': 'Select the desired time slot',

  'home.info.2.option-3.title': 'Email confirmation',
  'home.info.2.option-3.sub-title':
    'You will receive a confirmation email that you can show at the time of admission.',

  'home.info.3': 'Management of your documents',
  'home.info.3.tag': 'Documents',
  'home.info.3.subtitle': 'Manage documents online',
  'home.info.3.text':
    'With {tenant}, you can release documents relevant to your treatment to your doctor in advance. After your treatment, any findings and other released documents are also available for download here.',
  'home.info.3.option-1.title': 'Upload files',
  'home.info.3.option-1.sub-title': 'You can upload files via the upload icon.',

  'home.info.3.option-2.title': 'View documents',
  'home.info.3.option-2.sub-title':
    'In the Documents tab, you can view and manage all the documents you have uploaded. Here you can also view findings and other documents released by medical staff.',

  'home.info.4': 'Two-factor authentication',
  'home.info.4.tag': 'Security',
  'home.info.4.subtitle': 'Double protection for your {tenant} account',
  'home.info.4.text':
    'To further protect your account from potential attackers, we use two-factor authentication.',
  'home.info.4.option-1.title': 'Login',
  'home.info.4.option-1.sub-title': 'Login with your account credentials.',

  'home.info.4.option-2.title': 'Email code',
  'home.info.4.option-2.sub-title':
    'If the last login was some time ago, you will be redirected to a 2FA page after login. You will receive an email from us with which you can confirm the registration.',

  'home.info.4.option-3.title': 'Enter PIN',
  'home.info.4.option-3.sub-title':
    'Enter the code contained in the email in the PIN field to confirm the registration.',

  'home.app': 'Smartphone App',
  'home.app.subtile': 'Download today and discover benefits',
  'home.app.text':
    'Our app is available to download for free from the App Store and Google Play Store now',

  'home-qa.title': 'Do you have any questions?',
  'home-qa.subtitle': 'Answers to the most frequently asked questions',

  'home.qa.1.question': 'Are my data safe?',
  'home.qa.1.answer':
    'Your data is protected by the use of state-of-the-art encryption technologies. As a result, your data remains confidential and is only available to you and your medical professionals.',
  'home.qa.2.question': 'I cannot keep my appointment. What can I do? (Rebooking and cancellation)',
  'home.qa.2.answer':
    'If you cannot keep your appointment, you can cancel it in the appointment overview.',
  'home.qa.2.reschedule': 'Cancel appointmentsn',
  'home.qa.3.question': 'Do I have to pay anything to use {tenant}?',
  'home.qa.3.answer': 'No. We provide our platform completely free of charge.',
  'home.qa.4.question': 'What is there to consider after booking my appointment?',
  'home.qa.4.answer':
    'After booking your appointment, you will receive a confirmation email with a QR code that you can show at the admission. This does not contain any personal data and is only used to identify your appointment.',
  'home.qa.4.content':
    'Depending on the type of appointment, you may be asked to edit tasks or release additional information or files. You can view information on this in the respective appointment overview.',
  'home.qa.5.question': 'I have not received a confirmation email',
  'home.qa.5.answer':
    'If you have not received a confirmation for your appointment, you can always open the QR code in the appointment overview.',
  'home.qa.5.content': 'Appointment overview',

  'home.appointment': 'Online appointment booking',
  'home.unverified-user': 'You have not verified your account yet.',
  'home.unverified-user.description':
    'Please verify your account to be able to make appointment requests. To do so, simply open the link we sent you in the confirmation email to the email address {email}.',
  'home.unverified-user.verify': 'Account management',

  'home.hello': 'Hello, {name}',
  'home.find-your-appointment': 'Find your appointment',
  'home.documents': 'Your documents',
  'home.appointment.meta': 'With {tenant}, booking an appointment online has never been easier.',
  'home.create-appointment': 'Arrange appointment',
  'home.see-documents': 'View documents',
  'home.documents.meta':
    'Here you can view your medical documents and findings. We guarantee for your data security.',

  'home.data-security': 'Data security',
  'home.data-security.meta':
    'Your data is protected by the use of state-of-the-art encryption technologies.',
  'home.data-security.more': 'Learn more',

  'home.portal-user-invite.title': 'Link Account',
  'home.portal-user-invite.description':
    'Please enter your date of birth to complete the account linkage.',
  'home.portal-user-invite.decline': 'Decline',
  'home.portal-user-invite.verify-and-link': 'Verify and Link Account',
  'home.portal-user-invite.account-linked': 'Account linked',
  'home.portal-user-invite.linkage-failed': 'Linkage failed',
  'home.portal-user-invite.cancelled-or-invalid':
    'The linkage is invalid or has expired. Please contact the clinic.',
  'home.portal-user-invite.date-of-birth': 'Date of Birth',
  'home.portal-user-invite.wrong-dob': 'Incorrect date of birth. {tries} attempts remaining',
};
